import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CaretUpOutlinedSvg from "@ant-design/icons-svg/es/asn/CaretUpOutlined";
import AntdIcon from "../components/AntdIcon";
var CaretUpOutlined = function CaretUpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CaretUpOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CaretUpOutlined.displayName = 'CaretUpOutlined';
}
export default /*#__PURE__*/React.forwardRef(CaretUpOutlined);